<app-menu-bar></app-menu-bar>

<div id="contact">
    <div class="texts">
        <div class="pill">{{ 'contact_pill' | translate }}</div>
        <div class="title">{{ 'contact_title' | translate }}</div>
        <div class="description">{{ 'contact_description' | translate }}</div>
        <div class="contact-info">
            <div class="d-flex gap-2">
                <img src="assets/images/contact/phone.svg" alt="">
                <span>(+30) 2109215310</span>
            </div>
            <div class="d-flex gap-2">
                <img src="assets/images/contact/marker.svg" alt="">
                <a class="address-link" href="https://goo.gl/maps/jo5MgTTpMMmHisg29" target="_blank"
                    rel="noopener noreferrer">
                    <span>{{ 'contact_address' | translate }}</span>
                </a>
            </div>
        </div>
    </div>
    <div class="contact-form">
        @if (sent) {
        <!-- Replaces the form rather than blanking it, so it is obvious the
             message went somewhere. -->
        <div class="sent-panel">
            <div class="sent-check">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M4 12.5l5 5L20 6.5" />
                </svg>
            </div>
            <span class="sent-title">{{ 'contact_sent_title' | translate }}</span>
            <span class="sent-text">{{ 'contact_sent_text' | translate }}</span>
            <button type="button" class="sent-again" (click)="sendAnother()">
                {{ 'contact_sent_another' | translate }}
            </button>
        </div>
        } @else {
        <div class="input-area">
            <span class="label">{{ 'contact_field_name' | translate }}</span>
            <input type="text" class="fyes-input" [(ngModel)]="name" #nameCtrl="ngModel"
                [ngClass]="{ 'is-invalid': submitted && !name }">
        </div>
        <div class="input-area">
            <span class="label">{{ 'contact_field_email' | translate }}</span>
            <input type="email" class="fyes-input" [(ngModel)]="email" #emailCtrl="ngModel"
                [ngClass]="{ 'is-invalid': submitted && (emailCtrl.invalid || !email) }" email>
        </div>
        <div class="input-area">
            <span class="label">{{ 'contact_field_phone' | translate }}</span>
            <input type="tel" class="fyes-input" [(ngModel)]="phone"
                [ngClass]="{ 'is-invalid': submitted && (!phone || phone.length !== 10) }" #phoneCtrl="ngModel"
                #phoneInput (ngModelChange)="sanitizePhone(phoneInput)">
        </div>
        <div class="input-area">
            <span class="label">{{ 'contact_field_message' | translate }}</span>
            <textarea class="fyes-input" [(ngModel)]="message" #messageCtrl="ngModel"
                [ngClass]="{ 'is-invalid': submitted && !message }"></textarea>
        </div>
        <div class="d-flex align-items-center justify-content-end"><button class="primary-btn"
                (click)="sendMessage(nameCtrl, emailCtrl, phoneCtrl, messageCtrl)">{{ 'contact_send' | translate }}</button></div>
        }
    </div>
</div>
<app-footer></app-footer>